import { Grid2 as Grid, Tab, Tabs } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useHeatReportContext } from "../../context/HeatReportContext";
import { useTableStyles } from "../../styles/useTableStyles";
import { CasterProcessData } from "./caster-process-data/CasterProcessData";
import { EAFProcessData } from "./eaf-process-data/EAFProcessData";
import { LabReport } from "./lab-report/LabReport";

export const HeatReportTabs: React.FC = () => {
	const classes = useTableStyles();
	const { heatId, stage } = useParams<{ heatId: string; stage: string }>();
	const navigate = useNavigate();
	const { state } = useHeatReportContext();
	const [value, setValue] = useState<string>(stage || "eaf");

	useEffect(() => {
		if (stage) {
			setValue(stage);
		}
	}, [stage]);

	const hasCasterProcess =
		state.heat?.CASProcessId != null && state.heat?.CASProcessId > 0;

	const handleChange = (_: React.ChangeEvent<{}>, newValue: string) => {
		// Prevent navigation to Caster tab if heat doesn't have a Caster process
		if (newValue === "caster" && !hasCasterProcess) {
			return;
		}
		setValue(newValue);
		if (heatId) {
			navigate(`/heat-report/${heatId}/${newValue}`);
		}
	};

	return (
		<Grid container spacing={1} alignItems="center">
			<Grid size={{ xs: 12 }} container justifyContent="center">
				<Tabs
					value={value}
					onChange={handleChange}
					classes={{
						root: classes.fileTabsRoot,
						indicator: classes.fileTabsIndicator,
					}}
				>
					<Tab
						label="EAF"
						value="eaf"
						classes={{
							root: classes.fileTabRoot,
							selected: classes.fileTabSelected,
						}}
					/>
					<Tab
						label="Caster"
						value="caster"
						disabled={!hasCasterProcess}
						classes={{
							root: classes.fileTabRoot,
							selected: classes.fileTabSelected,
						}}
					/>
					<Tab
						label="Lab"
						value="lab"
						classes={{
							root: classes.fileTabRoot,
							selected: classes.fileTabSelected,
						}}
					/>
				</Tabs>
			</Grid>

			<Grid size={{ xs: 12 }} style={{ marginTop: "-9px" }}>
				{stage === "eaf" && <EAFProcessData />}
				{stage === "caster" && <CasterProcessData />}
				{stage === "lab" && <LabReport />}
			</Grid>
		</Grid>
	);
};
